import type { ChangeEvent, FunctionComponent, KeyboardEvent } from "react";
import { useState } from "react";

import { tracking } from "shared/data";

import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { SearchEvent } from "scmp-app/components/tracking/google-analytics-4/types";
import { useCurrentPageType, useRouteHandler } from "scmp-app/lib/router/hooks";
import { page as SearchPage } from "scmp-app/pages/search";

import {
  Container,
  SearchInput,
  SearchInputContainer,
  StyledIconSearch,
  StyledIconSearchCancel,
  Wrapper,
} from "./styles";

type Props = {
  className?: string;
  defaultExpand?: boolean;
  onClick?: () => void;
  onMenuClose?: () => void;
};
export const HamburgerMenuSearchArea: FunctionComponent<Props> = ({
  className,
  defaultExpand = false,
  onClick,
  onMenuClose,
}) => {
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const pageType = useCurrentPageType();
  const routePush = useRouteHandler();

  const handleOnClick = () => {
    if (!isSearchOpen) {
      // GA4 21.1.1
      sendGA4Tracking({
        action: "click",
        category: "search",
        subcategory: "icon",
      } as SearchEvent);
    }

    setIsSearchOpen(!isSearchOpen);
  };

  const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleInput = (event: KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;

    if (key === "Enter" && inputValue) {
      // GA4 21.2.2
      sendGA4Tracking({
        action: "sys",
        category: "search",
        customized_parameters: {
          search_text: inputValue,
        },
        subcategory: "result",
      } as SearchEvent);

      onMenuClose?.();
      const { pathname, query } = SearchPage.route({ value: inputValue });
      void routePush(pathname, {
        query: { ...query, module: tracking.module.HamburgerMenu, pageType },
      });
    }
  };

  const closeClickedHandler = () => {
    setInputValue("");
  };

  return (
    <Container className={className}>
      <Wrapper $isExpanded={defaultExpand || isSearchOpen} onClick={onClick}>
        <StyledIconSearch onClick={handleOnClick} />
        <SearchInputContainer>
          <SearchInput
            onChange={onInputChange}
            onKeyUp={handleInput}
            placeholder="Search"
            type="text"
            value={inputValue}
          />
        </SearchInputContainer>
        {inputValue && <StyledIconSearchCancel onClick={closeClickedHandler} />}
      </Wrapper>
    </Container>
  );
};
